var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"#00807a"}},[_c('span',{staticClass:"white--text"},[_vm._v("© "+_vm._s(_vm.year))])])}
var staticRenderFns = []

export { render, staticRenderFns }